import { Button } from 'antd';
import React from 'react';
import { useDispatch } from 'react-redux';

import DefaultPageHeaderButton from 'components/buttons/DefaultPageHeaderButton';
import { useLogoutWithAppClear } from 'hooks/useLogoutWithAppClear';
import trackEvent from 'store/modules/tracking/actions';
import { EventType } from 'store/modules/tracking/types';

interface Props {
  isPageHeaderExtra?: boolean;
}

function LogOutButton({ isPageHeaderExtra }: Props): React.ReactElement {
  const dispatch = useDispatch();
  const logoutWithAppClear = useLogoutWithAppClear();

  const handleClick = () => {
    dispatch(
      trackEvent({
        type: EventType.LOG_OUT,
        data: { status: true, buttonLocation: 'Settings Page' }
      })
    );
    logoutWithAppClear();
  };

  if (isPageHeaderExtra) {
    return (
      <DefaultPageHeaderButton onClick={handleClick}>
        LOG OUT
      </DefaultPageHeaderButton>
    );
  }

  return (
    <Button type="primary" onClick={handleClick}>
      LOG OUT
    </Button>
  );
}

export default LogOutButton;
